import { AxisSwitcher, BorderGridContainer, Button, GridBox, H2, SpacerWrapper } from '@ahmdigital/ui';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { map } from 'lodash/fp';
import classNames from 'classnames';

import leadActions from '../../../../actions/request-a-call';
import people from '../../data/people';
import PersonTile from './components/person-tile';
import sharedStyles from '../../styles.module.sass';
import styles from './styles.module.sass';

type MeetTheTeamProps = {
  actions: {
    lead: {
      expand: (...args: unknown[]) => unknown;
    };
  };
};

const MeetTheTeam = ({ actions }: MeetTheTeamProps) => (
  <BorderGridContainer>
    <GridBox padding="1rem">
      <SpacerWrapper variant={['marginBottomSpacer4', 'marginTopSpacer4']}>
        <div className={classNames(sharedStyles.wrapper, styles.container)}>
          <H2 variant="marginBottomSpacer4">Meet the team</H2>
          <AxisSwitcher limit={3} threshold="60rem" space="2.5rem">
            {map(
              ({ image, name, startYear, quote }) => (
                <PersonTile image={image} name={name} startYear={startYear} quote={quote} key={name} />
              ),
              people,
            )}
          </AxisSwitcher>
          <Button variant={['border', 'marginTopSpacer5', 'white']} onClick={actions.lead.expand}>
            Request a call
          </Button>
        </div>
      </SpacerWrapper>
    </GridBox>
  </BorderGridContainer>
);

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    lead: bindActionCreators(leadActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(MeetTheTeam);

export { MeetTheTeam as MeetTheTeamForTest };
